const elPaginationKey = /* @__PURE__ */ Symbol("elPaginationKey");

export { elPaginationKey };
//# sourceMappingURL=constants.mjs.map
